export default class CountryError extends Error {
  constructor(message = "Invalid country") {
    super(message);
    this.name = "CountryError";
  }
}
